
import { defineComponent } from "vue";
import "@/assets/scss/patient/profile.scss";
import axios from "axios";
export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "profile-admin",
  data() {
    return {
      first_name: "",
      last_name: "",
      birthday: "",
      address: "",
      national_code: "",
      mobile: "",
      gender: "",
    };
  },
  methods: {
    fetchProfile() {
      axios
        .get("/operator")
        .then((res) => {
          console.log(res.data);
          if (res.data.id) {
            // console.log(res.data.first_name);
            this.first_name = res.data.first_name;
            this.last_name = res.data.last_name;
            this.birthday = res.data.birthday;
            this.address = res.data.address;
            this.national_code = res.data.national_code;
            this.mobile = res.data.mobile;
          }
        })
        .catch((error) => {
          console.log(error.status);
        });
    },
  },
  mounted() {
    this.fetchProfile();
  },
});
